import React, { Component } from "react";
import { Button, Card, CardGroup, Modal } from "react-bootstrap";
import { Checkbox } from "@material-ui/core";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import L from "leaflet";
import { MapContainer, TileLayer, LayersControl, GeoJSON } from "react-leaflet";
import hash from "object-hash";
import Axios from "../../redux/axiosHandlerGeo";
import GeoJsonLayer from "./GeoJsonLayer";
import kanchanpur from "../../geojson/kanchanpur.json";
import { infastructure } from "../../variable/global";
// import kanchanpur from "../../geojson/bedkot.json";
import { MdPlace } from "react-icons/md";
import "leaflet/dist/leaflet.css";
import "../../assets/css/homePageDescription.scss";
import { connect } from "react-redux";

class MunicipalityDescription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalShow: false,
            boundData: [],
            wholeGeojson: [],
            location: {
                lat: 27.938571,
                lng: 85.918619,
            },
            zoom: 11,
            checkbox: {},
            wholeGeoJSON: {},
            showGeoJSON: [],
            sectionTitle: "",
        };
    }
    // 	this.getMunicpalId = this.getMunicpalId.bind(this);
    // }

    // isGeoJsonAlreadyFetched = (field) => {
    // 	const { wholeGeoJSON } = this.state;
    // 	return Boolean(wholeGeoJSON[field]);
    // };

    // fetchGeoJSON = (changedData) => {
    // 	const body = {
    // 		industries: "institute/industries",
    // 		cultural_heritage: "institute/cultural_heritage",
    // 		gov_office: "institute/gov_office",
    // 		forest: "institute/forest",
    // 		offices: "institute/offices",
    // 		infrastructure: "institute/infrastructure",
    // 		economic: "institute/economic",
    // 		education: "institute/education",
    // 		security: "institute/security",
    // 		palika_related_office: "institute/palika_related_office",
    // 		public_places: "institute/public_places",
    // 		health: "institute/health",
    // 	};

    // 	return new Promise((resolve, reject) => {
    // 		Axios.get(`/api/geojson/${body[changedData]}`)
    // 			.then((result) => {
    // 				const wholeGeoJSON = this.state.wholeGeoJSON;
    // 				this.setState(
    // 					{
    // 						wholeGeoJSON: {
    // 							...wholeGeoJSON,
    // 							[changedData]: result.data,
    // 						},
    // 					},
    // 					() => resolve()
    // 				);
    // 			})
    // 			.catch((err) => reject());
    // 	});
    // };

    // arrangeAllOption = async () => {
    // 	const { checkbox } = this.state;

    // 	const showGeoJSON = [];
    // 	let dataToCheck = [];

    // 	dataToCheck = dataToCheck.concat(infastructure);
    // 	const data = dataToCheck.map(async (each, i) => {
    // 		if (checkbox[each.value]) {
    // 			if (!this.isGeoJsonAlreadyFetched(each.value))
    // 				await this.fetchGeoJSON(each.value);

    // 			showGeoJSON.push(this.state.wholeGeoJSON[each.value]);
    // 		}
    // 	});
    // 	// wait until all promises resolve
    // 	await Promise.all(data);

    // 	this.setState({ showGeoJSON });
    // };

    // handleChange = (e) => {
    // 	e.persist();
    // 	this.setState(
    // 		({ checkbox }) => ({
    // 			checkbox: {
    // 				...checkbox,
    // 				[e.target.name]: e.target.checked,
    // 			},
    // 		}),
    // 		this.arrangeAllOption
    // 	);
    // };

    // style(feature) {
    // 	let skin = "blue";
    // 	if (feature.properties.FIRST_GaPa === "Bhimdatta") {
    // 		skin = "green";
    // 	}
    // 	return {
    // 		fillColor: skin,
    // 		weight: 1,
    // 		opacity: 1,
    // 		color: "black",
    // 		fillOpacity: 0.3,
    // 	};
    // }

    componentDidMount() {
        const boundData = [
            {
                key: "पुर्व",
                keyEnglish: "East",
                value: "बेलबारी नगरपालिका",
                valueEnglish: "belbari Municipality",
                class: "col-md-12",
            },
            {
                key: "उत्तर",
                keyEnglish: "North",
                value: "केरावारी  गाउँपालिका",
                valueEnglish: "Kerabari Rural Municipality",
                class: "col-md-12",
            },
            {
                key: "पश्चिम",
                keyEnglish: "West",
                value: "इटहरी उप- महानगरपालिका ",
                valueEnglish: "Itahari Sub-Metropolitan Municipality",
                class: "col-md-12",
            },
            {
                key: "दक्षिण",
                keyEnglish: "South",
                value: "ग्रामथाम गाउँपालिका र बुढीगंगा गाउँपालिका ",
                valueEnglish:
                    "Gramtham Rural Municipality and Budiganga Rural Municipality",
                class: "col-md-12",
            },
            {
                key: "क्षेत्रफल",
                keyEnglish: "Area",
                value: "११०.१६ ( वर्ग कि.मी.)",
                valueEnglish: "110.16 (sq. Km.)",
                class: "col-md-12",
            },
            {
                key: " वडा संख्या",
                keyEnglish: "ward",
                value: "१२",
                valueEnglish: "12",
                class: "col-md-12",
            },
            {
                key: "अक्षांश तथा देशान्तर",
                keyEnglish: "latitude and longitude",
                value: "२६.६२८६८ , ८७.३४०४१",
                valueEnglish: "26.62868 , 87.34041",
                class: "col-12",
            },
            // {
            // 	key: "मुख्य सहरी क्षेत्र",
            // 	keyEnglish: "Main city area",
            // 	value: "",
            // 	class: "col-12",
            // },
        ];
        this.setState({ ...this.state, boundData });
    }
    getMunicipalBounds() {
        let modalClose = () => this.setState({ modalShow: false });
        return (
            <div className="col-lg-5 pb-5 d-flex">
                <Card>
                    <Card.Body>
                        <div className="d-flex pb-8">
                            <SVG
                                className="primary-icon"
                                src={toAbsoluteUrl(
                                    "media/hamropalika/svg/map_marker.svg"
                                )}
                                alt=""
                            />
                            <h2 className="font-weight-black pl-3 pt-6 homepage-heading">
                                {this.props.selectedLanguage == "nepali"
                                    ? "सिमाना"
                                    : "Boundaries"}
                            </h2>
                        </div>
                        <div className="row">
                            {this.state.boundData.map((data, index) => {
                                return (
                                    <div
                                        className={`pb-3 ${data.class}`}
                                        key={index}
                                    >
                                        <div className="row">
                                            <div className="col-4">
                                                <h5 className="pr-2">
                                                    {this.props
                                                        .selectedLanguage ==
                                                    "nepali"
                                                        ? data.key
                                                        : data.keyEnglish}
                                                    :
                                                </h5>
                                            </div>
                                            <div className="col-8">
                                                <h5 className="text-primary">
                                                    {this.props
                                                        .selectedLanguage ==
                                                    "nepali"
                                                        ? data.value
                                                        : data.valueEnglish}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="float-right ">
                            <Button
                                className="px-10 emergency-button text-danger"
                                variant="light-danger"
                                size="lg"
                                onClick={() =>
                                    this.setState({ modalShow: true })
                                }
                            >
                                {" "}
                                <i className="icon-emergency"></i>{" "}
                                {this.props.selectedLanguage == "nepali"
                                    ? "आपतकालीन सम्पर्क"
                                    : "Emergency Contact"}
                            </Button>
                            {/* 
							<EmergencyContactModal
								selectedLanguage={this.props.selectedLanguage}
								show={this.state.modalShow}
								onHide={modalClose}
							/> */}
                        </div>
                    </Card.Body>
                </Card>
            </div>
        );
    }
    getMunicpalId() {
        return (
            <div className="col-lg-12 pb-5 d-flex ">
                <Card>
                    <Card.Body>
                        <div className="d-flex pb-8">
                            <SVG
                                className="primary-icon"
                                src={toAbsoluteUrl(
                                    "media/hamropalika/svg/municipality_id.svg"
                                )}
                                alt=""
                            />
                            <h2 className=" pl-3 pt-6 homepage-heading">
                                {this.props.selectedLanguage == "nepali"
                                    ? "गाउँपालिका अबस्थित  नक्शा"
                                    : "Rural Municipality Location Map"}
                            </h2>
                        </div>

                        <h4 className="col-lg-6 pb-5 d-flex">
                            {this.props.selectedLanguage === "nepali"
                                ? "पाल्पा जिल्लाको साविक हुँगी, फोक्सिङकोट, पिपलडाँडा, हुमिन, ताहुँ गरी ५ वटा गा.वि.स. र हेक्लाङ गा.वि.स. को वडा नं. ९ समेत गरी जम्मा ५ वटा वडा कायम गरी रम्भा गाउँपालिकाको घोषणा भएको छ । यस गाउँपालिकाको पूर्वतर्फ पूर्वखोला गाउँपालिका र रामपुर नगरपालिका, पश्चिम तर्फ माथागढी र बगनासकाली गाउँपालिका, उत्तर तर्फ कालीगण्डकी नदी र दक्षिण तर्फ माथागढी र पूर्वखोला गाउँपालिका रहेका छन् । यस गाउँपालिकामा प्रशिद्ध रम्भादेवीको मन्दिर रहेकोले यस गाउँपालिकाको नाम प्रशिद्ध शक्तिपिठ रम्भादेवीको नामबाट रम्भा गाउँपालिका नामाकरण गरिएको हो ।"+
"पाल्पा जिल्लाको सर्वोत्कृष्ट दोश्रो  शिखर रिमिघा लेक पनि यसै गाउँपालिकामा पर्दछ । यसका साथै प्रशिद्ध धार्मिक स्थल उत्तरबाहिनी क्षेत्र, रानिबास, हुँगीफाट, निकीचौर, अगाँहाखोला, गरुङ्गा आदी रमणीय पर्यटकीय क्षेत्रहरु पर्दछन् । यस गाउँपालिकाको पश्चिममा सिद्धार्थ राजमार्ग, उत्तर पूर्वमा कालिगण्डकी कोरिडोर, र दक्षिणमा रामपुर जोड्ने सडक रहेको छ । "+
"यस गाउँपालिकाको क्षेत्रफल ९४.१२ वर्ग किलोमिटर रहेको छ । रम्भा गाउँपालिकाको आ.व. २०७७/०७८मा गरेको घरधुरी सर्भेक्षण अनुसार यस पालिकाको कुल जनसंख्या २५९०७ रहेको छ । यहाँ मुख्यगरी मगर, ब्राह्मण, क्षेत्री र दलित जातिको वसोबास रहेको छ भने हिन्दु धर्म मान्ने समुदायको बाहुल्यता रहेको छ ।"
                                : "There are 5 village councils in Palpa district namely Hoongi, Phoksingkot, Pipaldanda, Humin, Tahun. and Heklang Ga.V.S. Ward no. A total of 5 wards including 9 have been announced as Rambha Rural Municipality. Purvkhola Rural Municipality and Rampur Municipality are on the east side of this rural municipality, Mathagadhi and Bagnaskali Rural Municipality are on the west side, Kaligandaki River is on the north side and Mathagadhi and Purvkhola Rural Municipality are on the south side. As there is a temple of the famous Rambhadevi in ​​this rural municipality, the name of this rural municipality was named after the famous Shaktipith Rambhadevi." +
"Rimigha Lake, the second best peak of Palpa district is also located in this rural municipality. Apart from this, there are famous religious places, Uttarbahini area, Ranibas, Hungiphat, Nikichour, Agahakhola, Garunga and other beautiful tourist areas. Siddhartha highway in the west of this rural municipality, Kaligandaki in the northeast"}
                        </h4>

                        {/* <div className="d-flex pb-8">
							<SVG
								className="primary-icon"
								src={toAbsoluteUrl("media/hamropalika/svg/map_marker.svg")}
								alt=""
							/>
							<h2 className="font-weight-black pl-3 pt-6">
								{this.props.selectedLanguage == "nepali"
									? "सिमाना"
									: "Boundaries"}
							</h2>
						</div> */}
                        <div className="col-lg-5 pb-5 d-flex">
                            <div className="row">
                                {this.state.boundData.map((data, index) => {
                                    return (
                                        <div
                                            className={`pb-3 ${data.class}`}
                                            key={index}
                                        >
                                            <div className="row">
                                                <div className="col-4">
                                                    <h5 className="pr-2">
                                                        {this.props
                                                            .selectedLanguage ==
                                                        "nepali"
                                                            ? data.key
                                                            : data.keyEnglish}
                                                        :
                                                    </h5>
                                                </div>
                                                <div className="col-8">
                                                    <h5 className="text-primary">
                                                        {this.props
                                                            .selectedLanguage ==
                                                        "nepali"
                                                            ? data.value
                                                            : data.valueEnglish}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        {/* <img
							className="w-100"
							src={toAbsoluteUrl("/media/hamropalika/bhotekoshiStatic.png")}
							alt=""
						/> */}
                    </Card.Body>
                </Card>
            </div>
        );
    }
    render() {
        return (
            <>
                <Card>
                    <Card.Body>
                        <Card.Title className="d-md-flex justify-space-between row">
                            <div className="d-flex col-md-6">
                                <SVG
                                    className="primary-icon"
                                    style={{ width: "32px" }}
                                    src={toAbsoluteUrl(
                                        "media/hamropalika/svg/municipality_id.svg"
                                    )}
                                    alt=""
                                />
                                <h2 className="font-weight-black pl-3 pt-5 homepage-heading">
                                    {this.props.selectedLanguage == "nepali"
                                        ? "गाउँपालिका संक्षिप्त परिचय"
                                        : "Rural Municipality Brief introduction"}
                                </h2>
                            </div>
                            <div id="destination">
                                <h2 className="font-weight-black pl-3 pt-5 homepage-heading">
                                    <MdPlace
                                        id="destination-icon"
                                        style={{ width: "32px" }}
                                    />{" "}
                                    {this.props.selectedLanguage == "nepali"
                                        ? "पर्यटकीय तथा महत्वपूर्ण स्थान"
                                        : "Tourist and important places"}
                                </h2>
                            </div>
                        </Card.Title>
                        <Card.Text>
                            <div className="row">
                                <div className="col-md-12 d-md-flex ">
                                    <div
                                        className="col-md-6 text-justify"
                                        id="intro-para"
                                    >
                                        <h4>
                                            {this.props.selectedLanguage ===
                                            "nepali"
                                                ? "पाल्पा जिल्लाको साविक हुँगी, फोक्सिङकोट, पिपलडाँडा, हुमिन, ताहुँ गरी ५ वटा गा.वि.स. र हेक्लाङ गा.वि.स. को वडा नं. ९ समेत गरी जम्मा ५ वटा वडा कायम गरी रम्भा गाउँपालिकाको घोषणा भएको छ । यस गाउँपालिकाको पूर्वतर्फ पूर्वखोला गाउँपालिका र रामपुर नगरपालिका, पश्चिम तर्फ माथागढी र बगनासकाली गाउँपालिका, उत्तर तर्फ कालीगण्डकी नदी र दक्षिण तर्फ माथागढी र पूर्वखोला गाउँपालिका रहेका छन् । यस गाउँपालिकामा प्रशिद्ध रम्भादेवीको मन्दिर रहेकोले यस गाउँपालिकाको नाम प्रशिद्ध शक्तिपिठ रम्भादेवीको नामबाट रम्भा गाउँपालिका नामाकरण गरिएको हो ।"+
"पाल्पा जिल्लाको सर्वोत्कृष्ट दोश्रो  शिखर रिमिघा लेक पनि यसै गाउँपालिकामा पर्दछ । यसका साथै प्रशिद्ध धार्मिक स्थल उत्तरबाहिनी क्षेत्र, रानिबास, हुँगीफाट, निकीचौर, अगाँहाखोला, गरुङ्गा आदी रमणीय पर्यटकीय क्षेत्रहरु पर्दछन् । यस गाउँपालिकाको पश्चिममा सिद्धार्थ राजमार्ग, उत्तर पूर्वमा कालिगण्डकी कोरिडोर, र दक्षिणमा रामपुर जोड्ने सडक रहेको छ । "+
"यस गाउँपालिकाको क्षेत्रफल ९४.१२ वर्ग किलोमिटर रहेको छ । रम्भा गाउँपालिकाको आ.व. २०७७/०७८मा गरेको घरधुरी सर्भेक्षण अनुसार यस पालिकाको कुल जनसंख्या २५९०७ रहेको छ । यहाँ मुख्यगरी मगर, ब्राह्मण, क्षेत्री र दलित जातिको वसोबास रहेको छ भने हिन्दु धर्म मान्ने समुदायको बाहुल्यता रहेको छ ।"
                                : "There are 5 village councils in Palpa district namely Hoongi, Phoksingkot, Pipaldanda, Humin, Tahun. and Heklang Ga.V.S. Ward no. A total of 5 wards including 9 have been announced as Rambha Rural Municipality. Purvkhola Rural Municipality and Rampur Municipality are on the east side of this rural municipality, Mathagadhi and Bagnaskali Rural Municipality are on the west side, Kaligandaki River is on the north side and Mathagadhi and Purvkhola Rural Municipality are on the south side. As there is a temple of the famous Rambhadevi in ​​this rural municipality, the name of this rural municipality was named after the famous Shaktipith Rambhadevi." +
"Rimigha Lake, the second best peak of Palpa district is also located in this rural municipality. Apart from this, there are famous religious places, Uttarbahini area, Ranibas, Hungiphat, Nikichour, Agahakhola, Garunga and other beautiful tourist areas. Siddhartha highway in the west of this rural municipality, Kaligandaki in the northeast"}
                                        </h4>
                                    </div>
                                    <div className="d-flex pb-8 d-sm-block d-md-none col-md-6 justify-content-start">
                                        <h2 className="font-weight-black pl-3 pt-5 homepage-heading text-left">
                                            <MdPlace
                                                id="destination-icon"
                                                style={{ width: "32px" }}
                                            />{" "}
                                            {this.props.selectedLanguage ==
                                            "nepali"
                                                ? "पार्यटकीय तथा महत्वपूर्ण स्थान"
                                                : "Tourist and important places"}
                                        </h2>
                                    </div>
                                    <div className="col-md-6 overflow-auto">
                                        <div className="card-content text-justify">
                                            <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/pic1.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "रम्भादेवी मन्दिर"
                                                                : "Rambhadevi Temple"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "पुर्बी पाल्पाको ताहूमा रहेको रम्भादेवीको ऐतिहासिक महत्व भएको धार्मीक पर्यटकिय स्थल हो । मगर जातीहरुको वाहुल्यता रहेको पुर्वी पाल्पामा रम्भादेवी सवै जाती जनजातीहरुको आस्थाको केन्द्रबिन्दु पनि हो ।"
                                                            : "Rambhadevi is a religious tourist place with historical importance in Tahu of Purbi Palpa. Rambhadevi is also the center of faith of all castes in Eastern Palpa where Magar castes predominate."}
                                                    </p>
                                                </div>
                                            </div>
                                            {/* <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/kichkandi.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div
                                                    className="card-body"
                                                    id="card-body"
                                                >
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "किचकगढी सिमसार"
                                                                : "Kichkagarhi Wetlands"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left overflow-hidden">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "वडा नम्बर १ डागी टोल (मदन आश्रित मार्ग देखि लक्षिण लक्ष्मीपुर सम्म) मा पर्ने यस किचकगढी सिमसार क्षेत्र ऐतिहासिक पुरातात्विक र धार्मिक गढीको रुपमा परिचित रहेको छ | यस क्षेत्र महाभारतमा किच्चकलाई वध गरेको ठाउँ भएको भन्ने किम्बदन्तिमा उल्लेख रहेको भनाई स्थानीयको रहेको छ | हरेक वर्ष यस स्थानमा वैशाख १४ गते परम्परागत पूजनोत्सव सहित मेला लाग्ने गरेको छ | हाल यो गढी साँगुरो र होचो हुँदै गएको छ । गढी वरिपरिका जलाशय तथा धापहरु पूरा समाप्त भई सुख्खा खेती योग्य जमिनमा परिणत हुँदै गएका, पुराना र ठूला रुखहरु सम्पूर्ण काटिई उजाड भएका छन् ।यस महत्वपूर्ण स्थानको संरक्षण तथा यस गढीको महत्वलाई उजागर गर्न यसको विकास र प्रवद्र्धन गर्न जरुरि देखिन्छ |"
                                                            : "This Kichkagarhi Wetland located in Ward No. 1 Dagi Toll (from Madan Ashrit Marg to Lakshin Lakshmipur) is known as a historical archaeological and religious site. Locals say that this area is the place where Kichchak was killed in the Mahabharata. Every year, a fair is held at this place on the 14th of Baisakh along with the traditional worship festival Currently, this fort is getting narrower and narrower. The reservoirs and dhaps around the fort have been completely depleted and converted into dry arable land, old and large trees"}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/hasinaSimsar.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "हसिना सिमसार "
                                                                : "Hasina Wetlands"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "वडा नम्बर ५ हसिना टोलमा अवस्थित यस हसिना सिमसार ४९ हेक्टर क्षेत्रमा फैलिएको छ | झट्ट हेर्दा पहाडका ससाना थुम्काहरू रहेको ठाउँजस्तो देखिने हसिना सिमसार क्षेत्र पहाड नभएर एउटा झोडा क्षेत्र हो।  सिमसार क्षेत्रमा बुद्ध बिहार, बुद्ध पोखरी, बुढासुब्बा मन्दिर, नाग पोखरी, साकेला थान, शिवालय मन्दिर आदि धार्मिक क्षेत्रहरु पनि बनाइएको छ  | यस क्षेत्रमा धार्मिक पर्यटकहरुको पनि आकर्षक गन्तव्य बन्दै गएको छ |  बहुसङ्ख्यक देवीदेवताका मन्दिर, विभिन्न प्रजातिका वनस्पति, जीवजन्तु, र पशुपन्छीको बासस्थानसमेत रहेको सो क्षेत्र पर्यटकीय क्षेत्र मात्र नभै वनभोज, अध्ययन–अनुसन्धान र अवलोकनका लागिसमेत उत्तिकै उपयोगी रहेको छ । मिनि जु, विभिन्न कलाकृति र ६ वटा सानाठूला पोखरीले पनि हसिनाको आकर्षण बढाएको छ ।यस क्षेत्रमा बँदेल, मृग, दुम्सी, खरायो, वनकुखुरा, सिमकुखुरा र बाँदर लगायत विभिन्न जातका बन्यजन्तु तथा पशुपन्क्षीहरू पाइन्छन्।"
                                                            : "Located in Ward No. 5 Hasina Tol, this Hasina Wetland is spread over an area of ​​49 hectares At first glance, the Hasina wetlands, which look like small hillocks, are not mountains, but a scrubland. Religious areas such as Buddha Bihar, Buddha Pond, Budhasubba Temple, Nag Pond, Sakela Than, Shivalaya Temple etc. have also been built in the wetland area. This area is also becoming an attractive destination for religious tourists There are many temples of Gods and Goddesses, various species of plants, animals, and animals Different species of wild animals and birds including wild boar, deer, cow, rabbit, forest fowl, guinea fowl and monkey are found in this area."}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/nayaVrindavan.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "नयाँ वृन्दावन गौशालाः सुन्दरहरैंचा "
                                                                : "New Vrindavan Gaushala: Sundarharaicha"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "धार्मिक पर्यटन क्षेत्रको विकास प्रवर्द्धन प्रचारप्रसार गर्ने हेतुले यो वृन्दावन गौशाला सुन्दरहरैचा नगरपालिका वडा नम्बर ५ बुढीखोलातर्फ निर्माण गरिदै छ | द्वापरयुगमा भगवान् श्रीकृष्णले आफ्नो कृष्णलीला देखाएको पवित्र तीर्थस्थल वृन्दावन गौशालालाई सचित्ररूपमा जस्ताको त्यस्तै निर्माण गर्ने अभियान नयाँ वृन्दावन गौशालामा थालनी गरिएको छ   |  चार कठ्ठा जमिनबाट निर्माण सुरु गरिएको यो धार्मिकग्राम अहिले सात बिघाभन्दा बढी क्षेत्रफलमा पुगिसकेको छ भने सो क्षेत्रमा नेपालकै ठूलो राधाकृष्णको मन्दिरको निर्माण भइरहेको छ र विश्वकै ठूलो गाईको प्रतिमा निर्माण गर्न डीपीआर तयार भएको छ । अहिले निर्माण भइरहेको नयाँ वृन्द्रावन गौशालामा हाल गाई र बाच्छाबाच्छीसमेत संरक्षण गरिएको छ भने नदी नियन्त्रणका लागि वृक्षरोपणका कामहरूसमेत भएका छन् । नयाँ वृन्दावन गौशालामा गाईको विशाल प्रतिमा स्थापित गरिएको छ |"
                                                            : "This Vrindavan Cowshed is being constructed towards Sundararaicha Municipality Ward No. 5 Budhikhola in order to promote the development of religious tourism sector. In the Dwapara Yuga, the campaign to build the holy shrine Vrindavan Gaushala, where Lord Krishna performed his Krishna Leela, has been started in New Vrindavan Gaushala. The construction of this religious village, which was started from four acres of land, has now reached an area of ​​more than seven bighas, and the largest Radhakrishna temple in Nepal is being built in that area."}
                                                    </p>
                                                </div>
                                            </div> */}
                                            {/* <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/tatopanibhansar.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "सुख्खा बन्दरगाह तातोपानी भन्सार"
                                                                : "Dry port hot water customs"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "तातोपानी गाउँ, सिन्धुपाल्चोक, बागमती प्रदेश ,  नेपालको उत्तरी सिमाना चीनसँग, काठमाडौंबाट ११४ किमी उत्तर पूर्वमा अवस्थित छ। लाङटाङको तातोपानी र रसुवा चीनसँगको नेपालको दुई मुख्य नाका हुन्। नेपाल निर्यात र आयात हुने समानहरुको चेक जांच सहित भन्सारको नियमित कार्य यहाँबाट हुने गरेको छ |"
                                                            : "Tatopani village, Sindhupalchowk, Bagmati province, Nepal's northern border with China, is located 114 km northeast of Kathmandu. Tatopani and Rasuwa of Langtang are the two main ports of Nepal with China. Regular customs operations are carried out from here, including check check of goods exported and imported from Nepal"}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/dhugunagadhi.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "दुगुना गढी"
                                                                : "Double fortress"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "सुन्दरहरैँचा नगरपालिका वडा नम्बर ३ मा पर्ने दुगुना गढीलाई देशको दश महत्त्वपूर्ण किल्ला मध्ये एक मानिन्छ |  इतिहासकारका अनुसार  तत्कालीन प्रधानमन्त्री जङ्गबहादुर राणाले सन् १८५५-१८५६ मा तिब्बतको आक्रमणबाट सहरको रक्षा गर्न निर्माण गरेको उल्लेख गरिएको छ ।"
                                                            : "Duguna Gadhi in Bhotekoshi Gaonpalika Ward No. 3 is considered as one of the ten most important forts in the country According to historians, it was built by the then Prime Minister Jung Bahadur Rana in 1855-1856 to protect the city from the invasion of Tibet."}
                                                    </p>
                                                </div>
                                            </div> */}
                                            {/* <div className="card" id="card">
												<img
													className="card-img-top"
													src="https://images.unsplash.com/photo-1656414563496-34686606f2ce?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
													alt=""
												/>
												<div className="card-body">
													<p className="card-text text-left">
														Some example text some example text. John Doe is an
														architect and engineer
													</p>
												</div>
											</div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedLanguage: state.ward.selectedLanguage,
});
export default connect(mapStateToProps)(MunicipalityDescription);
